exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsection[data-v-165f44d0]{\n  padding: 50px 0;\n}\nsection.header-section[data-v-165f44d0]{\n  padding: 0 !important;\n}\n\n", ""]);

// exports
